import type { ButtonStyle } from "@velizhanin-dev/bot-scenario"
import { cn } from "@/shared/lib/utils"
import { SegmentedControl } from "@/shared/ui/segmented-control"

/** Цвета кнопок Telegram: так их рисует приложение в тёмной теме. */
export const BUTTON_STYLE_COLORS: Record<ButtonStyle, string> = {
	primary: "#3e88f7",
	success: "#31b545",
	danger: "#e5453d",
}

const OPTIONS = [
	{ value: "none", label: "Обычная" },
	{ value: "primary", label: <Swatch style="primary" label="Синяя" /> },
	{ value: "success", label: <Swatch style="success" label="Зелёная" /> },
	{ value: "danger", label: <Swatch style="danger" label="Красная" /> },
] as const

function Swatch({ style, label }: { style: ButtonStyle; label: string }) {
	return (
		<span className="flex items-center gap-1.5">
			<span className="size-2.5 rounded-full" style={{ background: BUTTON_STYLE_COLORS[style] }} />
			{label}
		</span>
	)
}

/** Точка цвета рядом с пунктом в списке. Без цвета ничего не рисует. */
export function StyleDot({ style, className }: { style?: ButtonStyle; className?: string }) {
	if (!style) return null
	return (
		<span
			aria-label={`Цвет кнопки: ${{ primary: "синий", success: "зелёный", danger: "красный" }[style]}`}
			className={cn("inline-block size-2.5 shrink-0 rounded-full", className)}
			style={{ background: BUTTON_STYLE_COLORS[style] }}
		/>
	)
}

export function ButtonStylePicker({
	value,
	onChange,
}: {
	value: ButtonStyle | null
	onChange: (value: ButtonStyle | null) => void
}) {
	return (
		<SegmentedControl
			aria-label="Цвет кнопки"
			size="sm"
			options={OPTIONS}
			value={value ?? "none"}
			onChange={(next) => onChange(!next || next === "none" ? null : next)}
		/>
	)
}
